exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js!./src/common/scss/element-variables.scss
// module id = 624
// module chunks = 26